import { MainCleanersComponent } from "./components/main-cleaners.component";
import { MainCleanerComponent } from "./components/main-cleaner.component";
import {RouterModule, Routes} from "@angular/router";
import { NgModule } from '@angular/core';
import { AuthService } from '../../injections/auth.service';

export const appRoutes: Routes = [
    {
        path: 'cleaners',
        component: MainCleanersComponent,
        canActivate: [AuthService]
    },
    {
        path: 'cleaners/:id',
        component: MainCleanerComponent,
        canActivate: [AuthService]
    },
   
];

@NgModule({
    imports: [
        RouterModule.forChild(appRoutes)
    ],
    exports: [
        RouterModule
    ],
    declarations: [],
    providers: [],
})
export class CleanersRoutes { }


// WEBPACK FOOTER //
// ./src/app/modules/cleaners/cleaners.routes.ts